<template>
  <flash-modal
    id="flash-modal-error"
    type="error"
  />
</template>

<script>
  import FlashModal from '@/components/modals/FlashModal'

  export default {
    name: 'ErrorFlashModal',
    components: {
      FlashModal
    }
  }
</script>
